module.exports = __webpack_public_path__ + "img/platiza.b51544a6.svg";